import ky from "ky";
import { SERVER_ROOT } from "./constants";

export const apiClient = ky.extend({
  prefixUrl: `${SERVER_ROOT}/`,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});
